import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { createNoobookUser, modifyTerms } from '../api/UserAuthApi';
import { getAccessToken } from '../react-queries/queries';
import { useLogoutMutation } from '../react-queries/mutations';

const Wrapper = styled.div`
  padding: 24px;
  max-width: 480px;
  margin: 0 auto;
`;
const Title = styled.h2`
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 16px;
`;
const AgreementBox = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
`;
const CheckRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;
const CheckLabel = styled.label`
  flex: 1;
  font-size: 1rem;
`;
const ViewBtn = styled.button`
  margin-left: 8px;
  color: #2a3eb1;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
`;
const AgreeBtn = styled.button`
  width: 100%;
  padding: 16px 0;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 24px;
  cursor: pointer;
  &:disabled { background: #bdbdbd; cursor: not-allowed; }
`;
const Overlay = styled.div`
  position: fixed;
  z-index: 9999;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(255,255,255,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
`;
const Spinner = styled.div`
  border: 6px solid #eee;
  border-top: 6px solid #2a3eb1;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;
  @keyframes spin {
    0% { transform: rotate(0deg);}
    100% { transform: rotate(360deg);}
  }
`;
const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  font-size: 2rem;
  color: #888;
  cursor: pointer;
  z-index: 10;
`;
const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin-bottom: 16px;
`;

export default function AgreementPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [all, setAll] = useState(false);
  const [service, setService] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [sms, setSms] = useState(false);
  const [marketEmail, setMarketEmail] = useState(false);
  const [push, setPush] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // 전체동의 체크 시 하위 항목 모두 체크/해제
  const handleAll = () => {
    const next = !all;
    setAll(next);
    setService(next);
    setPrivacy(next);
    setMarketing(next);
    setSms(next);
    setMarketEmail(next);
    setPush(next);
  };

  const handleMarketing = () => {
    const next = !marketing;
    setMarketing(next);
    if (next) {
      setSms(true);
      setMarketEmail(true);
      setPush(true);
    } else {
      setSms(false);
      setMarketEmail(false);
      setPush(false);
    }
  };

  // 필수 항목 모두 체크 시에만 동의하기 버튼 활성화
  const canProceed = service && privacy;
  const { afterLogin:afterLogin, loginId:loginid, password:passwd, name, email } = location.state || {};
  const { mutate: logout, isPending } = useLogoutMutation();

  const handleAgree = async () => {
    
    if(afterLogin){
      try{
        setIsSubmitting(true);
        const accessToken = await getAccessToken();
        const res = await modifyTerms(accessToken.accessToken?accessToken.accessToken:''
          , {agreementConfirmed: service
          , privacyPolicyConfirmed: privacy
          , marketingConfirmed: marketing
          , marketingSmsConfirmed: sms
          , marketingEmailConfirmed: marketEmail
          , marketingApppushConfirmed: push
        });
        if (res.errorCode === 0) {
          alert('가입을 축하합니다.');
          navigate('/home');
        } else {
          alert(`가입절차를 완료하지 못하였습니다. (${res.errorCode})`);
          logout(undefined, {
            onSuccess: () => {
              navigate('/login');
            }
          });
        }
      }catch(e){
        const msg = e instanceof Error ? e.message : String(e);
        alert('가입절차를 완료하지 못하였습니다. (네트워크 오류)' + msg);
        logout(undefined, {
          onSuccess: () => {
            navigate('/login');
          }
        });
      }finally{
        setIsSubmitting(false);
      } 
    }else{
      try{
        setIsSubmitting(true);
        const res = await createNoobookUser({
          loginid: loginid,
          passwd: passwd,
          name: name ? name : loginid,
          agreementConfirmed: service,
          privacyPolicyConfirmed: privacy,
          marketingConfirmed: marketing,
          marketingSmsConfirmed: sms,
          marketingEmailConfirmed: marketEmail,
          marketingApppushConfirmed: push,
          email: email
        });
        if (res.errorCode === 0) {
          alert('가입을 축하합니다.');
          navigate('/login/form');
        } else {
          alert(`가입절차를 완료하지 못하였습니다. (${res.errorCode})`);
        }
      } catch (e) {
        const msg = e instanceof Error ? e.message : String(e);
        alert('가입절차를 완료하지 못하였습니다. (네트워크 오류)' + msg);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleClose = () => {
    if(afterLogin){
      logout(undefined, {
        onSuccess: () => {
          navigate('/login');
        }
      });
    } else {
      navigate('/signup');
    }
  };

  return (
    <Wrapper>
      {isSubmitting && <Overlay><Spinner /></Overlay>}
      <TitleRow>
        <Title>이용 약관에 동의해주세요.</Title>
        <CloseButton onClick={handleClose} aria-label="닫기">×</CloseButton>
      </TitleRow>
      <AgreementBox>
        <CheckRow>
          <input type="checkbox" checked={all} onChange={handleAll} id="all" />
          <CheckLabel htmlFor="all"><b>전체동의</b></CheckLabel>
        </CheckRow>
        <div style={{margin: '12px 0', color: '#888', fontSize: '0.95rem'}}>아래 모든 약관 및 마케팅 안내 수신(선택) 내용을 확인 및 동의합니다.</div>
        <CheckRow>
          <input type="checkbox" checked={service} onChange={() => { setService(v => !v); }} id="service" />
          <CheckLabel htmlFor="service">[필수] 서비스 이용약관</CheckLabel>
          <ViewBtn onClick={() => navigate('/terms/service')}>보기</ViewBtn>
        </CheckRow>
        <CheckRow>
          <input type="checkbox" checked={privacy} onChange={() => { setPrivacy(v => !v); }} id="privacy" />
          <CheckLabel htmlFor="privacy">[필수] 개인정보 수집 및 이용 동의</CheckLabel>
          <ViewBtn onClick={() => navigate('/terms/privacy')}>보기</ViewBtn>
        </CheckRow>
        <CheckRow>
          <input
            type="checkbox"
            checked={marketing}
            onChange={handleMarketing}
            id="marketing"
          />
          <CheckLabel htmlFor="marketing">[선택] 홍보 마케팅 목적 개인정보 수집 이용 동의</CheckLabel>
          <ViewBtn onClick={() => navigate('/terms/marketing')}>보기</ViewBtn>
        </CheckRow>
        <div style={{background:'#fafafa', borderRadius:8, padding:12, margin:'16px 0'}}>
          <CheckRow>
            <input
              type="checkbox"
              checked={sms}
              onChange={() => setSms(v => !v)}
              id="sms"
              disabled={!marketing}
            />
            <CheckLabel htmlFor="sms">문자(SMS)/알림톡 수신</CheckLabel>
          </CheckRow>
          <CheckRow>
            <input
              type="checkbox"
              checked={marketEmail}
              onChange={() => setMarketEmail(v => !v)}
              id="marketEmail"
              disabled={!marketing}
            />
            <CheckLabel htmlFor="marketEmail">이메일 수신</CheckLabel>
          </CheckRow>
          <CheckRow>
            <input
              type="checkbox"
              checked={push}
              onChange={() => setPush(v => !v)}
              id="push"
              disabled={!marketing}
            />
            <CheckLabel htmlFor="push">앱 푸시</CheckLabel>
          </CheckRow>
        </div>
        <AgreeBtn disabled={!canProceed || isSubmitting} onClick={handleAgree}>동의하기</AgreeBtn>
      </AgreementBox>
    </Wrapper>
  );
} 